import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Schedule} from '../models/schedule';

const API = environment.API;

@Injectable({
  providedIn: 'root',
})
export class ScheduleService {

  constructor(private http: HttpClient) {
  }

  getByPlaceId(placeId: string, date: string, excludeHoldId = false) {
    const params = {date, excludeHoldId};
    return this.http.get<Schedule>(`${API}/api/schedules/place/${placeId}`, {params});
  }

  getByRoomId(roomId: string, date: string, duration: number, excludeBookingId = false) {
    const params = {date, duration, excludeBookingId};
    return this.http.get<Schedule>(`${API}/api/schedules/room/${roomId}`, {params});
  }

  getByRoomIdByPartOfDay(roomId: string, date: string, partOfDay: string, duration: number, excludeBookingId = false) {
    const params = {date, partOfDay, duration, excludeBookingId};
    return this.http.get<Schedule>(`${API}/api/schedules/room/${roomId}/partOfDay`, {params});
  }

  findByPlaceIds(placeIds: string[], date: string, excludeHoldId = false) {
    const params = {placeIds, date, excludeHoldId};
    return this.http.get<Schedule[]>(`${API}/api/schedules/places`, {params});
  }

  findByRoomIds(roomIds: string[], date: string, duration: number, excludeBookingId = false) {
    const params = {roomIds, date, duration, excludeBookingId};
    return this.http.get<Schedule[]>(`${API}/api/schedules/rooms`, {params});
  }

  findByRoomIdsByPartOfDay(roomIds: string[], date: string, partOfDay: string, duration: number, excludeBookingId = false) {
    const params = {roomIds, date, partOfDay, duration, excludeBookingId};
    return this.http.get<Schedule[]>(`${API}/api/schedules/rooms/partOfDay`, {params});
  }

  findMeetings(search: string, showInvisible = false, limit = 1000, skip = 0) {
    const params = {search, showInvisible, limit, skip};
    return this.http.get<Schedule[]>(`${API}/api/searches/meeting`, {params});
  }

}
